import { defineMessages } from 'react-intl'

const messages = defineMessages({
    codeInputAriaLabel: {
        id: 'codeInputAriaLabel',
        defaultMessage: 'Elemento {index} de {size} para ingresar el código. Presione la tecla de tabulación para avanzar al siguiente campo.',
    },
})

export default messages